import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { TimeBucketUnits } from '@iotv/datamodel-core';
import { SortOrder } from '@iotv/iotv-v3-types';
import { TabPanel } from '@mui/lab';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { NetWorkDAO } from '../../../../data/NetworkDAO';
const debug = process.env.REACT_APP_DEBUG && false;
export const GatewayMetricsTab = ({ value }) => {
    const [metrics, setMetrics] = useState([]);
    const [errMsg, setErrMsg] = useState(null);
    const metricsQuery = async () => {
        const query = {
            units: TimeBucketUnits.HOUR.valueOf(),
            duration: 1,
            fromDateValue: dayjs().subtract(2, 'day'),
            toDateValue: dayjs(),
            // gatewaySks: [ 'Gateway:[uuid]'],
            sortOrder: SortOrder.DESCENDING,
        };
        const { err, data } = await NetWorkDAO.geGatewayMetricsFromTimestream(query);
        if (err) {
            setErrMsg(err.message);
        }
        if (data) {
            setErrMsg(null);
            setMetrics(data);
        }
    };
    useEffect(() => {
        metricsQuery();
    }, []);
    return (_jsxs(TabPanel, { value, children: [_jsx(Typography, { variant: 'h6', children: "Gateway Metrics Query test" }), _jsxs(Stack, { direction: 'column', children: [_jsxs(Stack, { direction: 'row', children: [_jsx(Typography, { children: "Metrics" }), JSON.stringify(metrics)] }), _jsxs(Stack, { direction: 'row', children: [_jsx(Typography, { children: "Error?" }), errMsg ?? 'none'] })] })] }, 'batchPut'));
};
